module.exports = __webpack_public_path__ + "img/GP1_Slovenia - ABC Entrepreneurship.b2a37a2c.jpg";